import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MonitoringService } from '@core/services/monitoring.service';
import { environment } from '@env/environment';
import { classifyError, ErrorClassification } from '../error-classification';

import { IconSizeET } from '@liberty-financial/ng-components/lib/components/icon/icon.enum';
import { IconLibraryTypes } from '@liberty-financial/ng-components/lib/components/icon/library.enum';

@Component({
  selector: 'app-failure',
  templateUrl: './failure.component.html',
  styleUrls: ['./failure.component.scss']
})
export class FailureComponent implements OnInit {
  @Input() error: any = null

  get errorClassification(): ErrorClassification {
    return classifyError(this.error)
  }

  get message(): string {
    switch (this.errorClassification) {
      case 'NetworkConnectionIssue':
        return 'A problem was encountered while communicating with the server. Please check your internet connection, and try again.'
      case 'ItemNotFound':
        return 'Sorry we can\'t seem to find what you were looking for.'
      case 'UnsupportedVersion':
        return 'A new version of Spark+ is available. Please refresh your browser to continue.'
      case 'Terminal':
        let message = 'Uh-oh! An unexpected error occurred. If the issue persists, please contact support.';

        if (environment.production) {
          return message;
        }

        return message + `\n\n${this.error.message}`;
    }
  }

  get severityClass(): string {
    switch (this.errorClassification) {
      case 'NetworkConnectionIssue': return 'warning'
      case 'ItemNotFound': return 'warning'
      case 'UnsupportedVersion': return 'info'
      case 'Terminal': return 'danger'
    }
  }

  get icon(): IconLibraryTypes {
    switch (this.errorClassification) {
      case 'NetworkConnectionIssue': return 'offline'
      case 'ItemNotFound': return 'search'
      case 'UnsupportedVersion': return 'sync'
      case 'Terminal': return 'smiley-sad'
    }
  }

  @Input() sizeClass: IconSizeET = 'lg';

  constructor(private monitoringService: MonitoringService) { }

  ngOnInit() {
    if (this.errorClassification == 'Terminal') {
      if (this.error instanceof HttpErrorResponse) {
        this.monitoringService.logException(this.error);
      } else {
        let errorToLog = new Error();
        if (this.error?.message) {
          errorToLog.message = this.error.message;
        } else {
          errorToLog.message = JSON.stringify(this.error);
        }
        this.monitoringService.logException(errorToLog);
      }
    }
  }
}
